import { render, staticRenderFns } from "./TraceabilityResultsItem.vue?vue&type=template&id=355013a9&scoped=true"
import script from "./TraceabilityResultsItem.vue?vue&type=script&lang=js"
export * from "./TraceabilityResultsItem.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityResultsItem.vue?vue&type=style&index=0&id=355013a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355013a9",
  null
  
)

export default component.exports